interface CompanyStoryProps {
  story: {
    title: string;
    description: string;
    foundedYear: number;
    milestones: Array<{
      year: number;
      title: string;
      description: string;
    }>;
  };
}

export default function CompanyStory({ story }: CompanyStoryProps) {
  return (
    <section className="bg-card py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-headline font-bold text-primary mb-4">
            {story.title}
          </h2>
          <p className="text-lg text-textSecondary max-w-3xl mx-auto leading-relaxed">
            {story.description}
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-border hidden lg:block" />
          
          <div className="space-y-12">
            {story.milestones.map((milestone, index) => (
              <div
                key={milestone.year}
                className={`relative flex flex-col lg:flex-row items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                <div className="w-full lg:w-5/12 mb-4 lg:mb-0">
                  <div
                    className={`bg-surface p-6 rounded-lg shadow-subtle ${
                      index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'
                    }`}
                  >
                    <div className="text-2xl font-headline font-bold text-primary mb-2">
                      {milestone.year}
                    </div>
                    <h3 className="text-xl font-headline font-semibold text-textPrimary mb-2">
                      {milestone.title}
                    </h3>
                    <p className="text-textSecondary leading-relaxed">
                      {milestone.description}
                    </p>
                  </div>
                </div>

                <div className="hidden lg:flex w-2/12 justify-center">
                  <div className="w-4 h-4 bg-primary rounded-full border-4 border-card shadow-subtle" />
                </div>

                <div className="w-full lg:w-5/12" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}